export default __webpack_public_path__ + "static/51f01bf8-c568-40b2-af85-6bff46971ecb-7b9ebe22306e21d3d8aa2e94153dc1ac.woff2";